export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const advantages = [
    { icon: 'ri-search-eye-line', text: 'Предварительная диагностика переговорной практики компании' },
    { icon: 'ri-user-voice-line', text: 'Переговорные поединки и разбор реальных кейсов' },
    { icon: 'ri-hand-heart-line', text: 'Достижение взаимовыгодных соглашений — win-win стратегия' },
    { icon: 'ri-refresh-line', text: 'Сопровождение и поддержка после обучения' },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/a74a1966-be20-475d-bd44-2c6a9fc46c98/f3f397a0-cfb7-42ac-ab53-5390f840d006_compressed_VAL02483.webp"
          alt="Алексей Сивко — тренинг по переговорам для компаний"
          className="absolute top-1/2 left-1/2 w-[177.77777778vh] min-w-full h-[56.25vw] min-h-full -translate-x-1/2 -translate-y-1/2 object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pt-28 md:pt-20 pb-10 md:pb-16">
        <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3 text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-5 leading-tight">
              Тренинг по переговорам для компаний
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-4 leading-relaxed max-w-2xl font-medium">
              Практическое корпоративное обучение переговорам для руководителей и сотрудников
            </p>
            <p className="text-base text-white/75 mb-8 leading-relaxed max-w-2xl">
              Не теория коммуникации. Системная работа: диагностика переговорной практики, практическое обучение с переговорными поединками, разбор реальных кейсов и сопровождение внедрения. Работаем с командами из Беларуси, России, Казахстана и Израиля.
            </p>

            <div className="space-y-3 mb-10">
              {advantages.map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/80 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-sm text-white`}></i>
                  </div>
                  <span className="text-sm md:text-base">{item.text}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mb-16 md:mb-0">
              <button
                onClick={() => scrollTo('contact')}
                className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center"
              >
                Заказать тренинг переговоров
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                onClick={() => scrollTo('contact')}
                className="bg-white/15 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center border border-white/30"
              >
                Обсудить задачу
                <i className="ri-chat-1-line"></i>
              </button>
            </div>
          </div>

          <div className="lg:col-span-2 hidden lg:block">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden bg-teal-600 flex-shrink-0">
                  <img
                    src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                    alt="Алексей Сивко"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-white font-bold text-lg">Алексей Сивко</div>
                  <div className="text-white/70 text-sm">Бизнес-тренер, эксперт по переговорам</div>
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/60 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-calendar-check-line text-sm text-white"></i>
                  </div>
                  <span className="text-sm">18+ лет практики</span>
                </div>
                <div className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/60 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-2-line text-sm text-white"></i>
                  </div>
                  <span className="text-sm">100+ корпоративных проектов</span>
                </div>
                <div className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/60 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-presentation-line text-sm text-white"></i>
                  </div>
                  <span className="text-sm">450+ тренингов</span>
                </div>
                <div className="flex items-center gap-3 text-white/90">
                  <div className="w-8 h-8 bg-teal-600/60 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-star-line text-sm text-white"></i>
                  </div>
                  <span className="text-sm">4500+ участников</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}